import * as React from "react"
import { useEffect } from "react"
import { Box } from "@mui/material"

import { CommonFilters } from "@components"
import {COMMON_FILTER_KEYS, STOCK_ROUTES} from "@constants"
import { useAppDefaultFilters } from "@hooks"
import {isLoadingCommonFilters, isSystemBusy} from "@signals"
import { useStockShareRoleConfig } from "./@hooks"
import { stockShareIsEmpty } from "./signals"


export default function StockShareFilters() {

	const { callUserDefaultFilters, userFilters, isLoadingDefaultFilters } = useAppDefaultFilters(STOCK_ROUTES.STOCK_SHARE_ID, STOCK_ROUTES.ACCESS_KEY)

	useEffect(() => {
		callUserDefaultFilters()
	}, [])

	const { isMarketplacesUser } = useStockShareRoleConfig()

    return <Box data-tour="share-filters">
    <CommonFilters
		components={{
			country: true, site: true,
			category: true, brand: true,
			sku: true, favFilters: true,
			favFiltersOnlyLine: true, skuGroup: true,
			seller: isMarketplacesUser
		}}
		compProps={{
			country: { disableClearable: true },
			sku: { grid: { md: isMarketplacesUser ? 4 : 6 } },
			favFiltersOnlyLine: { grid: { md: 10 } },
			favFilters: {
				allowedFilters: [
					COMMON_FILTER_KEYS.COUNTRY, COMMON_FILTER_KEYS.RETAILER, COMMON_FILTER_KEYS.CATEGORY, COMMON_FILTER_KEYS.BRAND,
					COMMON_FILTER_KEYS.SKU_GROUP, COMMON_FILTER_KEYS.SKU
				],
				dashboardKey: STOCK_ROUTES.STOCK_SHARE_ID
			}
		}}
		onSubmit={() => {
			stockShareIsEmpty.value = false
			isSystemBusy.value = false
			isLoadingCommonFilters.value = true
		}}
		defaultValues={userFilters}
		isLoadingDefaultFilters={isLoadingDefaultFilters}
	/>
    </Box>
}